import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TNil } from '../app.interface';

@Injectable({
  providedIn: 'root',
})
export class FormUtilitiesService {
  private static lastHighlightedElementIds = new Map<string, string | null>();

  public static scrollToFirstError(targetElementName?: string, delayInMs = 0): boolean {
    const firstErrorElement = document.querySelector(`${targetElementName ?? ''} mat-form-field.ng-invalid`);

    requestAnimationFrame(() => {
      setTimeout(() => {
        if (firstErrorElement) {
          firstErrorElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          });
        }
      }, delayInMs);
    });

    return !!firstErrorElement;
  }

  public static scrollTo(targetElementName?: string, delayInMs = 0, tryDelayedElementFind = false): boolean {
    const targetElement = document.querySelector(targetElementName ?? '');

    requestAnimationFrame(() => {
      setTimeout(() => {
        const element =
          tryDelayedElementFind && !targetElement ? document.querySelector(targetElementName ?? '') : targetElement;

        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          });
        }
      }, delayInMs);
    });

    return !!targetElement;
  }

  public static highlightNewElement(
    form: FormGroup,
    namespace: string,
    parentId?: string | TNil,
    duration = 500,
    scrollToElement = false,
  ): void {
    const elementId = form.get('id')?.value ?? '';

    if (!elementId) {
      return;
    }

    if (!this.lastHighlightedElementIds.has(namespace)) {
      this.lastHighlightedElementIds.set(namespace, null);
    }

    this.lastHighlightedElementIds.set(namespace, elementId);

    if (scrollToElement) {
      requestAnimationFrame(() => {
        setTimeout(() => {
          this.scrollToElement(elementId, parentId);
        });
      });
    }

    setTimeout(() => {
      if (this.lastHighlightedElementIds.get(namespace) === elementId) {
        this.lastHighlightedElementIds.set(namespace, null);
      }
    }, duration);
  }

  public static isNewlyHighlightedElement(elementId: string, namespace: string): boolean {
    return this.lastHighlightedElementIds.get(namespace) === elementId;
  }

  private static scrollToElement(id: string, parentId?: string | TNil): void {
    const element = document.querySelector(
      `${parentId ? `[data-element-id="${parentId}"]` : ''} [data-element-id="${id}"]`,
    );

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}
